import { render, staticRenderFns } from "./PlayerInforRadar.vue?vue&type=template&id=b2c6cf9a&scoped=true"
import script from "./PlayerInforRadar.vue?vue&type=script&lang=js"
export * from "./PlayerInforRadar.vue?vue&type=script&lang=js"
import style0 from "./PlayerInforRadar.vue?vue&type=style&index=0&id=b2c6cf9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c6cf9a",
  null
  
)

export default component.exports